module.exports = __webpack_public_path__ + "static/media/MX-BUSD.c74d603b.svg";